import { page, shows, type FeatureRoutes } from "@/app/feature";

const screens = page(() => import("./Screens"));

export const routes: FeatureRoutes = {
  shell: [
    {
      path: "me",
      lazy: screens,
      handle: shows("profile", "progression", "achievements", "cards", "collection"),
    },
    { path: "me/achievements", lazy: screens, handle: shows("achievements") },
    { path: "players/:username", lazy: screens, handle: shows("profile", "market") },
  ],
};
